import { getRandomModeActive, isEditingQueue } from "../reducers/randomMode";
import { setClearQueueForPlayAlbum } from "./clearQueueActions";
import { deleteAlbumFromQueue, enqueueAlbum, enqueueAlbumAsFirst, rerandomizeAlbumFromQueue, setAlbumFromQueueAsPointed } from "./randomModeActions";

export const SET_CONTEXT_MENU_OPENED = 'SET_CONTEXT_MENU_OPENED';
export const SET_CONTEXT_MENU_COORDS = 'SET_CONTEXT_MENU_COORDS';
export const SET_CONTEXT_MENU_OPTIONS = 'SET_CONTEXT_MENU_OPTIONS';

export const setContextMenuOpened = opened => ({ type: SET_CONTEXT_MENU_OPENED, payload: opened });
export const setContextMenuCoords = coords => ({ type: SET_CONTEXT_MENU_COORDS, payload: coords });
export const setContextMenuOptions = content => ({ type: SET_CONTEXT_MENU_OPTIONS, payload: content });

export const setContextMenu = (options, clickEvent) => {
    return (dispatch) => {
        setTimeout(() => {
            dispatch(setContextMenuOpened(true));
            dispatch(setContextMenuCoords({x: clickEvent.pageX, y: clickEvent.pageY}));
            dispatch(setContextMenuOptions(options));
        }, 10);
    }
}

export const setAlbumItemContextMenu = (album, clickEvent) => {
    return (dispatch, getState) => {
        const state = getState();
        const randomModeActive = getRandomModeActive(state);

        const getOptions = () => {
            const defaultOptions = [
                {
                    text: "Play album",
                    onClick: () => dispatch(setClearQueueForPlayAlbum(album))
                },
                {
                    text: "Enqueue as first",
                    onClick: () => dispatch(enqueueAlbumAsFirst(album, false))
                },
                {
                    text: "Enqueue as last",
                    onClick: () => dispatch(enqueueAlbum(album))
                }
            ];

            if(randomModeActive) {
                return [
                    {
                        text: "Play album",
                        onClick: () => dispatch(enqueueAlbumAsFirst(album, true))
                    },
                    {
                        text: "Enqueue as next",
                        onClick: () => dispatch(enqueueAlbumAsFirst(album, false))
                    },
                    {
                        text: "Enqueue as last",
                        onClick: () => dispatch(enqueueAlbum(album))
                    }
                ]
            }

            return defaultOptions;
        }

        if(clickEvent.type === 'click' && !randomModeActive)
        {
            return;
        }

        dispatch(setContextMenu(getOptions(), clickEvent));
    }
}

export const setRandomQueueItemContextMenu = (album, queueIndex, isCurrentAlbum, canDeleteAlbum, clickEvent) => {
    return (dispatch, getState) => {
        const state = getState();
        const editingMode = isEditingQueue(state);

        if(editingMode)
        {
            return;
        }

        const onClickPlay = () => dispatch(setAlbumFromQueueAsPointed({queueIndex, startRandomMode: true}));
        const onClickRerandomize = () => dispatch(rerandomizeAlbumFromQueue(album, queueIndex));
        const onClickDelete = () => {
            if(!canDeleteAlbum) return;
            dispatch(deleteAlbumFromQueue(album, queueIndex));
        };
        
        const getOptions = () => {
            let options = [];

            if(!isCurrentAlbum) {
                options = [...options, {
                    text: "Play now",
                    onClick: onClickPlay
                }];
            }

            options = [...options, {
                text: "Rerandomize",
                onClick: onClickRerandomize
            }];

            if(canDeleteAlbum) {
                options = [...options, {
                    text: "Delete from queue",
                    onClick: onClickDelete
                }];
            }

            return options;
        }

        dispatch(setContextMenu(getOptions(), clickEvent));
    }    
}